export default {"src":"/_next/static/media/assistant-cook-with-medium-grey-text-box.dc592a76.svg","height":359,"width":301};